export class NotificationRecordableOwner {
    public notificationId: number; 
    public edhContactId: number; 
    public notificationRecordableOwnerId: number; 
}